export const sharedStyles = {
  header: {
    backgroundColor: "#1B3A2D",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "-2em -3em 0",
    width: "calc(100% + 6em)",
    padding: "28px 3em 32px",
    borderRadius: "8px 8px 0 0",
    gap: "8px",
    boxSizing: "border-box",
  },
  headerBrand: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  headerLogo: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#4CAF50",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerLogoImg: {
    width: "24px",
    height: "24px",
  },
  headerTitle: {
    color: "#FFFFFF",
    fontSize: "22px",
    fontWeight: "700",
    margin: "0",
    lineHeight: "1.3",
  },
  headerSubtitle: {
    color: "#4CAF50",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "32px 0 8px",
    fontFamily: "Inter, sans-serif",
  },
  pageTitle: {
    color: "#0D1B2A",
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    margin: "0 0 24px",
    lineHeight: "1.3",
  },
  actionButton: {
    border: "none",
    borderRadius: "12px",
    padding: "18px 24px",
    fontSize: "17px",
    fontWeight: "700",
    width: "100%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    letterSpacing: "0.01em",
  },
};
